import { t } from 'i18next';
import { Box, Stack, Typography } from '@mui/material';
import { MessageHeaderProps } from '../types';

export const MessageHeader = ({ authorName, isCurrentUser }: MessageHeaderProps) => (
  <Stack className="history-author"
    display="flex"
    flexDirection="row"
    justifyContent={isCurrentUser ? 'flex-end' : 'flex-start'}
    alignItems="center"
    pb={1}
    gap={2}
  >
    <Box gap={1} display="flex">
      <Box display="flex" gap={1} alignItems="center">
        <Typography variant="subtitle2">{authorName}</Typography>
        <Typography variant="body2" color="text.secondary">
          {t('cases.view.content.emailText')}
        </Typography>
      </Box>
    </Box>
  </Stack>
);
